import { BranchService } from '@/modules/global-settings/company/services/branch.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the branch service
const branchService = new BranchService();

// Branch module state
export const state = {
  branches: [],
  branch: {}
};

// Branch module mutations
export const mutations = {
  ...make.mutations(state),

  ADD_BRANCH: (state, payload) => {
    state.branches.push(payload);
  },

  UPDATE_BRANCH: (state, { id, payload }) => {
    const index = state.branches.findIndex((el) => el.id == id);
    state.branches.splice(index, 1, payload);
  }
};

// Branch module actions
export const actions = {
  /**
   * Fetch all branches
   * @param {*} Object - Vuex context
   * @returns Array - Branches
   */
  fetchBranches: async ({ commit }) => {
    try {
      const { data } = await branchService.findAll();
      commit('SET_BRANCHES', data);
      return data
    } catch (error) {
      Logger.error('fetching branches');
      throw error;
    }
  },

  /**
   * Fetch a branch bt the given id
   * @param {*} Object - Vuex context
   * @param {*} id - Branch ID
   * @returns Object - Branch
   */
  fetchBranch: async ({ commit }, id) => {
    try {
      const { data } = await branchService.findOne(id);
      commit('SET_BRANCH', data);
      return data;
    } catch (error) {
      Logger.error('fetching branch');
      throw error;
    }
  },

  /**
   * Create a new branch with the data provided
   * @param {*} Object - Vuex context
   * @param {*} payload - Branch data
   * @returns Object - Branch that was created
   */
  createBranch: async ({ commit }, payload) => {
    try {
      const { data } = await branchService.create(payload);
      commit('ADD_BRANCH', data);
      return data;
    } catch (error) {
      Logger.error('create branch');
      throw error;
    }
  },

  /**
   * Update a branch with the given id and data
   * @param {*} Object - Vuex context
   * @param {*} Object - Branch ID & Branch data
   */
  updateBranch: async ({ commit }, { id, payload }) => {
    try {
      await branchService.update(id, payload);
      commit('UPDATE_BRANCH', { id, payload });
    } catch (error) {
      Logger.error('updating branch');
      throw error;
    }
  },

  /**
   * Delete a branch with the given id - Not used within production
   * @param {*} Object - Vuex context
   * @param {*} id - Branch ID
   */
  deleteBranch: async ({ dispatch }, id) => {
    try {
      await branchService.delete(id);
      dispatch('fetchBranches');
    } catch (error) {
      Logger.error('deleting branch');
      throw error;
    }
  }
};

// Branch module getters
export const getters = make.getters(state);
